define('regexp',[], function() {
    function rE(xp) {
        var names = [null], _return,
            regex = xp.replace(/([^\\]?)\(\?<([a-z_-]+)>|([^\\]?)\(/g, function(match, d, name, back) {
                if (name) {
                    names.push(name); // Save the names of each index match to allow named capture.
                    return d + '(';
                }
                names.push(null);
                return match;
            });

        _return = new RegExp(regex);
        _return.names = names;
        return _return;
    }

    rE.replace = function(str, re, to, flags) {
        if (typeof str === 'undefined' || str === null) {
            throw new TypeError();
        }
        str = String(str);

        re = (typeof re === 'string' ? new RegExp(re) : re);
        var names = re.names;

        switch (flags) {
            case 'all':
                re.toString().replace(/^\/(.*)\/([a-z]*)$/g, function(match, regex, flags) {
                    re = new RegExp(regex, flags.replace(/(g|$)/, 'g'));
                });
                break;
            case 'one':
                re.toString().replace(/^\/(.*)\/([a-z]*)$/g, function(match, regex, flags) {
                    re = new RegExp(regex, flags.replace('g', ''));
                });
                break;
        }

        if (typeof names === 'undefined') {
            return str.replace(re, to);
        }

        var l = names.length, i;

        if (typeof to === 'function') {
            return str.replace(re, function() {
                // @todo Figure out whether String constructor is necessary here
                var match = new String(arguments[0]), args = arguments;
                for (i = 1; i < l; i++) {
                    if (names[i]) {
                        match[names[i]] = arguments[i];
                    }
                }
                args[0] = match;
                return to.apply(this, args); // Apply modified arguments to mimic original behavior (but with named capture)
            });
        }

        for (i = 1; i < l; i++) {
            to = to.replace('${' + names[i] + '}', '$' + i);
        }

        return str.replace(re, to);
    };

    rE.exec = function(str, re, pos, sticky) {
        if (typeof re !== 'object' || re instanceof RegExp === false) {
            throw new TypeError();
        }
        if (typeof pos === 'undefined') {
            pos = 0;
        } else {
            re.lastIndex = 0;
        }

        str = String(str);

        var match = re.exec(
            (typeof sticky === 'undefined' || !sticky) ? str.substr(pos) : str.substr(pos)[0]
        );
        if (!match) {
            return match;
        } else if (typeof re.names !== 'undefined') {
            var l = re.names.length, i;

            for (i = 1; i < l; i++) {
                if (re.names[i]) {
                    match[re.names[i]] = match[i-1];
                }
            }
        }

        match.index += pos;
        match.input = str;
        return match;
    };
    return rE;
});

